<template>
    <div class="row mb--md">
        <div class="col-4">
            <router-link to="/chat" exact-active-class="btn--gray-active" class="btn btn--md btn--block btn--gray">Chat</router-link>
        </div>
        <div class="col-4">
            <router-link to="/friends" exact-active-class="btn--gray-active" class="btn btn--md btn--block btn--gray"><span
                class="status status--success"></span> Friends</router-link>
        </div>
        <div class="col-4">
            <router-link to="/add-friend" exact-active-class="btn--gray-active" class="btn btn--md btn--block btn--gray">Add friend</router-link>
        </div>
    </div>
</template>

<script>
export default {
name: "chatMenu"
}
</script>
